import { createVNode } from "vue"
import { Modal } from "ant-design-vue";
import { ExclamationCircleOutlined } from "@ant-design/icons-vue";

/**
 * title
 * success
 * toastText
*/
export const showModal = (modal) => {
    const { title, success, toastText, cancel } = modal;
    Modal.confirm({
        title: () => title,
        icon: () => createVNode(ExclamationCircleOutlined),
        content: () => toastText,
        cancelText: '取消',
        onOk() {
            success();
        },
        onCancel() {
            if (cancel) {
                cancel();
            }
        },
    });
};
